import { css } from '@emotion/react';

const makeLocationIconStyles = ({ theme }) => {
  return {
    icon: css({
      color: theme.mvf.palette.text.secondaryTextColor,
      marginRight: theme.mvf.spacing.smedium,
    }),
  };
};

export default makeLocationIconStyles;
